import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  height: "24px",
  width: "24px",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21.062 21.064",
  style: {"fill":"currentColor"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      id: "close",
      transform: "translate(-569.969 -84.969)"
    }, [
      _createElementVNode("path", {
        id: "close-2",
        "data-name": "close",
        d: "M38.94,20,20,38.943m18.941,0L20,20",
        transform: "translate(551.031 66.03)",
        fill: "none",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-miterlimit": "10",
        "stroke-width": "1.5"
      })
    ], -1)
  ])))
}